import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalDia = () => {

return(
<div>
    
<Typography variant="h6" >

WFS1 rs10010131 A/G is associated with a heightened risk of T2DM, particularly in obese T2DM patients in Iraqi Arab patients    <br />
WFS1 rs6446482 Mutations in the WFS1 gene cause β-cell death, leading to Wolfram syndrome and diabetes. There have been few studies that have been linked to T2DM and the rs6446282 polymorphism in the WFS1 gene 
<br /><br /> 
PAX4 Polymorphisms rs2233575 and rs712701 in the paired box 4 gene are not associated with type 1 diabetes in children  <br />
PAX4 Drug response: Paired box (PAX) genes are a family of genes that encode transcription factors. PAX4 is mainly expressed in the pancreas. PAX4 gene and its variants are important targets for T1D and other types of diabetes. 
<br /><br /> 
GATA4 List of variants in gene GATA4 reported as benign for Congenital heart disease     <br />   
GATA4 Mutations in the 3'-untranslated region of GATA4 as molecular hotspots for congenital heart disease (CHD). (SNPedia)
<br /><br /> 
SLC29A3 Drug response: Clinical Annotation for rs780668 (SLC29A3); gemcitabine; Carcinoma, Non-Small-Cell Lung (level 4 Efficacy)    <br />
SLC29A3 Allele C is not associated with risk of Neutropenia and Thrombocytopenia when treated with gemcitabine in people with Carcinoma, Non-Small-Cell Lung as compared to allele T.
<br /><br /> 
KCNJ11 Association of KCNJ11 and ABCC8 single-nucleotide polymorphisms with type 2 diabetes mellitus in a Kinh Vietnamese population  <br />
KCNJ11 The association between type-1 diabetes and rs5219 is mentioned as being replicated in [PMID 17554300OA-icon.png]; <br />
KCNJ11 rs5219 Genotype C/C -- reported as normal (SNPedia) versus increased risk for type-2-diabetes with other genotypes


<br /><br /> 

Sources: <br /><br />
https://hivnursing.net/index.php/hiv/article/view/529   <br />
https://www.sciencedirect.com/science/article/pii/S1018364721003839 <br />
https://www.sciencedirect.com/science/article/pii/S2214540018300252 <br />
https://clinvarminer.genetics.utah.edu/variants-by-gene/GATA4/condition/Congenital%20heart%20disease/benign <br />
https://www.pharmgkb.org/variantAnnotation/1449557574 <br />
https://pubmed.ncbi.nlm.nih.gov/36401380/<br />

 
</Typography>

</div>
)
}